import { Common } from '@sv-support-sdk/shared-types';

const lowerCase = (str: string) => str.toLowerCase();
const upperCase = (str: string) => str.toUpperCase();

const isArray = (arr: unknown | Common.Utils.ObjectTypes) => Array.isArray(arr);
const isObject = (obj: unknown | Common.Utils.ObjectTypes) =>
  obj === Object(obj) && !isArray(obj) && typeof obj !== 'function';

export const toCamelCase = (str: string) =>
  str
    .replace(/[\s_-](.)/g, upperCase)
    .replace(/[\s_-]/g, '')
    .replace(/^(.)/, lowerCase);

export const toCamelCaseRecursive = (obj: Common.Utils.ObjectTypes[] | Common.Utils.ObjectTypes | any): Common.Utils.ObjectTypes | any => {
  if (isObject(obj)) {
    const n: Common.Utils.ObjectTypes = {};

    Object.keys(obj).forEach((k: string) => {
      n[toCamelCase(k)] = toCamelCaseRecursive(obj[k]);
    });

    return n;
  }

  if (isArray(obj)) {
    return obj.map((i: Common.Utils.ObjectTypes[] | Common.Utils.ObjectTypes) => toCamelCaseRecursive(i));
  }

  return obj;
};

export const createUserNameFromEmail = (email: string) => {
  const userName = email.match(/^([^@]*)@/);
  return userName ? userName[1] : '';
};

export const getNumberFromString = (srt: string) =>
  (srt
      ? srt
        .split('')
        .map((el) => el.charCodeAt(0))
        .reduce((ac, el) => ac + el, 0)
      : 1
  ).toString();
